<mat-card appearance="outlined">
    <app-transformer-top-header [isReadOnly]="isReadOnly" [viewModel]="viewModel" [transformslists]="transformslists" [iconpath]="iconpath" [nodeColor]="nodeColor" [transformNameType]="transformNameType" [aboutlink]="aboutlink"
    [refineryConfigGuid]="refineryConfigGuid" [refineryName]="refineryName" [nodeName]="nodeName" [nodeIndex]="nodeIndex" [configGuid]="configGuid" [cacheStatus]="cacheStatus" (onRefreshCacheStatus)="getCacheStatus()" (onPurgeCache)="purgeCache()" [isTransformName]="false"
    (onTransformTextChanged)="onTransformTextChanged()" 
    (onViewTransformConfigJson)="viewTransformConfigJson()" 
    (onRunTransform)="onRunTransformValidate()" 
    (onSaveConfig)="saveConfig()" (onShowTransformDetail)="showTransformDetail($event)" (onImportTransformer)="loadImportTransformer($event)"
    [inputCacheKey]="copilotInputCacheKey"
    (onApplySmartSample)="applySmartSample($event)"></app-transformer-top-header>
    <mat-card-content class="content-with-fixed-header">
        <!-- Description -->
        <mat-expansion-panel class="mat-elevation-z0" style="margin-top:5px;">
            <mat-expansion-panel-header>Description</mat-expansion-panel-header>
            <app-transformer-description [analystDescription]="viewModel.transform.analystDescription"
                (analystDescriptionChange)="viewModel.transform.analystDescription = $event"></app-transformer-description>
        </mat-expansion-panel>
        <!-- Parameters -->
        <mat-expansion-panel class="mat-elevation-z0" expanded expanded style="margin-top:5px;">
            <mat-expansion-panel-header>Parameters<span *ngIf="isValidateParameters" class="mat-error" style="margin-left: 5px;">Missing Required Fields</span></mat-expansion-panel-header>
            <!-- <div style="display: flex"> -->
                  <div style="display: flex;margin-top: -10px;margin-left: -3px;">
                <div style="margin-right: 10px;">
                    <div>
                        <mat-form-field style="width: 100%;">
                            <mat-label>{{sortInfoa.label}}</mat-label>
                            <mat-chip-grid #chipList aria-label="Sort By">
                                <mat-chip-row *ngFor="let sortInfo of viewModel.sortInfo" (removed)="removeSortInfo(sortInfo)">
                                    {{sortInfo.sortField}}
                                    <mat-icon class="primary-color-icon" style="font-size: 8px"
                                        *ngIf="sortInfo.sortAscending" style="margin-left: 3px;">
                                        keyboard_arrow_down
                                    </mat-icon>
                                    <mat-icon class="primary-color-icon" style="font-size: 8px"
                                        *ngIf="!sortInfo.sortAscending" style="margin-left: 3px;">
                                        keyboard_arrow_up
                                    </mat-icon>
                                    <button matChipRemove>
                                        <mat-icon>cancel</mat-icon>
                                    </button>
                                </mat-chip-row>
                                <input style="cursor: pointer;" [readonly]="true" (click)="showSortBuilder()" matInput
                                    placeholder="Edit Columns..." #sortInfoInput [formControl]="sortCtrl"
                                    [matChipInputFor]="chipList">
                            </mat-chip-grid>
                        </mat-form-field>
                    </div> 
                </div>
                <div style="margin-right: 10px;">
                    <div>
                        <mat-form-field style="width: 205px;">
                            <mat-label>{{sortInfoOut.label}}</mat-label>
                            <mat-chip-grid #chipListIF aria-label="Sort By">
                                <mat-chip-row *ngFor="let sortInfo of viewModel.sortInfoOut" (removed)="removeSortInfoIF(sortInfo)">
                                    {{sortInfo.sortField}}
                                    <mat-icon class="primary-color-icon" style="font-size: 8px"
                                        *ngIf="sortInfo.sortAscending" style="margin-left: 3px;">
                                        keyboard_arrow_down
                                    </mat-icon>
                                    <mat-icon class="primary-color-icon" style="font-size: 8px"
                                        *ngIf="!sortInfo.sortAscending" style="margin-left: 3px;">
                                        keyboard_arrow_up
                                    </mat-icon>
                                    <button matChipRemove>
                                        <mat-icon>cancel</mat-icon>
                                    </button>
                                </mat-chip-row>
                                <input style="cursor: pointer;" [readonly]="true" (click)="showSortBuilderIF()" matInput
                                    placeholder="Edit Columns..." #sortInfoInputIF [formControl]="sortCtrlIF"
                                    [matChipInputFor]="chipListIF">
                            </mat-chip-grid>
                        </mat-form-field>
                    </div> 
                </div>
                <app-transformer-parameters [viewModel]="viewModel.parameters" [sourceColumns]="viewModel.sourceColumnsDT" 
                    (SetDefaultRule)="onSetDefaultRule($event)" 
                    (formStatus)="onParameterFormStatusChange($event)"></app-transformer-parameters>
                <div>
                    <div style="height: 30px;"></div>
                    <div style="margin-left: -168px;">
                        <mat-slide-toggle style="margin-top: 22px;" labelPosition="before" color="primary" (change)="onToggleResetRows($event)" [checked]="viewModel.resetRows" ><span [innerHTML]="resetRows.label"></span></mat-slide-toggle>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
        <!-- Advanced Settings -->
        <mat-expansion-panel class="mat-elevation-z0"  style="margin-top: 15px;">
            <mat-expansion-panel-header>Advanced Settings<span *ngIf="isValidateAdvanceSettings" class="mat-error" style="margin-left: 5px;">Missing Required Fields</span></mat-expansion-panel-header>
            <div style="display: flex;margin-top: -8px;">
                <div style="margin-left: -2px;">
                   <!-- <div>
                        <mat-form-field [formGroup]="form" appearance="legacy">
                            <mat-label>{{timestampFielda.label}}</mat-label>
                            <mat-select [(ngModel)]="viewModel.timestampField" formControlName="timestampFieldaField" (selectionChange)="onTimeStampSelectionChange($event.value)">
                                <mat-option *ngIf="timestampFielda.isselectblank"></mat-option>
                                <mat-option *ngFor="let col of dateTimeSourceColumns" [value]="col.text">{{col.text}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('timestampFieldaField').hasError('required')">{{viewModel.getValidationInfo('timestampFieldaField').errorMessage.replace("Advanced Settings: ","")}}</mat-error>
                        </mat-form-field>
                    </div>-->
                      <div [formGroup]="form">
                    <app-autocomplete-field-with-matform
                        formControlName="timestampFieldaField"
                        [options]="dateTimeSourceColumnsOptions"
                        [placeholder]="timestampFielda.label"
                        [(ngModel)]="viewModel.timestampField"
                        [required]="true"
                        (selectionChange)="onTimeStampSelectionChange($event)"
                    ></app-autocomplete-field-with-matform>

                   <mat-error *ngIf="form.get('timestampFieldaField')?.hasError('required')">
                        {{ viewModel.getValidationInfo('timestampFieldaField').errorMessage.replace('Advanced Settings: ', '') }}
                    </mat-error>
                    </div>
                                        <div>
                        <mat-form-field [formGroup]="form">
                            <mat-label>{{groupBy.label}}</mat-label>
                            <mat-select [(ngModel)]="viewModel.groupBy" formControlName="groupByField">
                                <mat-option *ngIf="groupBy.isselectblank"></mat-option>
                                <mat-option *ngFor="let col of strSourceColumns" [value]="col.text">{{col.text}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('groupByField').hasError('required')">{{viewModel.getValidationInfo('groupByField').errorMessage.replace("Advanced Settings: ","")}}</mat-error>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field [formGroup]="form">
                            <mat-label>{{groupByL2.label}}</mat-label>
                            <mat-select [(ngModel)]="viewModel.groupByL2" formControlName="groupByL2Field">
                                <mat-option *ngIf="groupByL2.isselectblank"></mat-option>
                                <mat-option *ngFor="let col of strSourceColumns" [value]="col.text">{{col.text}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('groupByL2Field').hasError('required')">{{viewModel.getValidationInfo('groupByL2Field').errorMessage.replace("Advanced Settings: ","")}}</mat-error>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-slide-toggle color="primary" [(ngModel)]="viewModel.sequenceL2" labelPosition="before" (change)="onToggleSequenceL2()">{{sequenceL2.label}} </mat-slide-toggle>
                    </div>
                </div>
                <div >
                    <div>
                        <mat-form-field [formGroup]="form">
                            <mat-label>{{defSourceFielda.label}}</mat-label>
                            <mat-select [(ngModel)]="viewModel.defSourceField" formControlName="defSourceFieldaField">
                                <mat-option *ngIf="defSourceFielda.isselectblank"></mat-option>
                                <mat-option *ngFor="let col of strSourceColumns" [value]="col.text">{{col.text}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('defSourceFieldaField').hasError('required')">{{viewModel.getValidationInfo('defSourceFieldaField').errorMessage.replace("Advanced Settings: ","")}}</mat-error>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field [formGroup]="form">
                            <mat-label>{{entityList.label}}</mat-label>
                            <mat-select [(ngModel)]="viewModel.entityList" formControlName="entityListField">
                                <mat-option *ngIf="entityList.isselectblank"></mat-option>
                                <mat-option *ngFor="let col of viewModel.entryListColumns" [value]="col">{{col}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('entityListField').hasError('required')">{{viewModel.getValidationInfo('entityListField').errorMessage.replace("Advanced Settings: ","")}}</mat-error>
                        </mat-form-field>
                    </div>
                   <!-- <div>
                        <mat-form-field [formGroup]="form" appearance="legacy">
                            <mat-label>{{userField.label}}</mat-label>
                            <mat-select [(ngModel)]="viewModel.userField" formControlName="userFieldField" (selectionChange)="onUserSelectionChange($event.value)">
                                <mat-option *ngIf="userField.isselectblank"></mat-option>
                                <mat-option *ngFor="let col of userSourceColumns" [value]="col.text">{{col.text}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('userFieldField').hasError('required')">{{viewModel.getValidationInfo('userFieldField').errorMessage.replace("Advanced Settings: ","")}}</mat-error>
                        </mat-form-field>
                    </div>-->
                      <div [formGroup]="form">
                    <app-autocomplete-field-with-matform
                        formControlName="userFieldField"
                        [options]="sourceColumnsOptions"
                        [placeholder]="userField.label"
                        [(ngModel)]="viewModel.userField"
                         [required]="true"
                        (selectionChange)="onUserSelectionChange($event)">
                    </app-autocomplete-field-with-matform>

                    <mat-error *ngIf="form.get('userFieldField')?.hasError('required')">
                        {{ viewModel.getValidationInfo('userFieldField').errorMessage.replace('Advanced Settings: ', '') }}
                    </mat-error>
                    </div>
                </div>
                <div  style="margin-top: 3px;">
                    <div>
                        <mat-form-field>
                            <mat-label>{{bufferRows.label}}</mat-label>
                            <input matInput type="number" placeholder="Buffer Rows" [(ngModel)]="viewModel.bufferRows" [required]="bufferRows.isrequired" [min]="bufferRows.min" [max]="bufferRows.max" appIntegerPositiveOnly>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field>
                            <mat-label>{{threads.label}}</mat-label>
                            <input matInput type="number" placeholder="Threads" [min]="0" [(ngModel)]="viewModel.threads" [required]="threads.isrequired" [min]="threads.min" [max]="threads.max" appIntegerPositiveOnly>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field [formGroup]="form">
                            <mat-label>{{listSeparator.label}}</mat-label>
                            <input matInput formControlName="separatorControl" type="text" [(ngModel)]="viewModel.listSeparator" [required]="listSeparator.isrequired" placeholder="Select the Separator."
                            [matAutocomplete]="autolistSeparator"
                            >
                            <mat-autocomplete autoActiveFirstOption #autolistSeparator="matAutocomplete">
                                <mat-option *ngFor="let separator of separatorOptions | async" [value]="separator.value">
                                    {{separator.text}}
                                </mat-option>
                            </mat-autocomplete>

                            <!-- <mat-select [(ngModel)]="viewModel.listSeparator" >
                                <mat-option *ngIf="listSeparator.isselectblank"></mat-option>
                                <mat-option value="|">|(pipe)</mat-option>
                                <mat-option value=":">: (colon)</mat-option>
                                <mat-option value=";">; (semicolon)</mat-option>
                                <mat-option value=",">, (comma)</mat-option>
                                <mat-option value="/">/ (slash)</mat-option>
                                <mat-option value=" ">  (spaces)</mat-option>
                            </mat-select> -->
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field>
                            <mat-label>{{defTimeout.label}}</mat-label>
                            <input matInput type="number" placeholder="Default Timeout (s)" [min]="0" [(ngModel)]="viewModel.defTimeout" [required]="defTimeout.isrequired" appIntegerPositiveOnly>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
        <!-- Field Converter Mapping -->
        <mat-expansion-panel class="mat-elevation-z0" expanded>
            <mat-expansion-panel-header>
                <div style="display: flex; align-items: center; justify-content: center;">
                    <span>Field Converter Mapping &nbsp;</span> 
                    <span *ngIf="isRequiredFieldMissing" > &nbsp; ( <span style="color: #FF0000;"> Field name in red </span> indicates this required field is missing from the input farm) </span>
                </div>
                <!-- <button style="padding: 2px 4px 0px 0px; margin-left: 32px; width: auto; line-height: 24px;"
                        color="primary" mat-raised-button (click)="$event.stopPropagation(); addNewRule()"
                        title="Add new rule">
                        <mat-icon style="font-size: 20px">add_circle</mat-icon>
                        ADD RULE
                    </button> -->

            </mat-expansion-panel-header>
            <!-- [style.max-height.px]="isRulesMaximized ? '100000' : '386'" -->
            <div 
                style="margin-top: 0px; margin-left: -6px; margin-right: -6px; padding-left: 6px; padding-right: 6px;">
                <h1 class="center" style=" color: lightgray" *ngIf="isRuleSetEmpty">No Rules</h1>

                <table>
                    <tr>
                        <td style="vertical-align: top;padding-right: 10px;">
                            <table *ngIf="!isRuleSetEmpty" mat-table 
                            [dataSource]="dataSource" #table class="drag-list mat-elevation-z8" cdkDropList
                            [cdkDropListData]="dataSource">

                            <ng-container matColumnDef="mapFrom">
                                <th mat-header-cell *matHeaderCellDef [style.--td-color]="getstylemapFrom()['--td-color']" class="td-colored">{{mapfromtext}} </th>
                                <td mat-cell *matCellDef="let rule" [style.--td-color]="getstylemapFrom(rule.mapFrom)['--td-color']" class="td-colored">
                                    {{rule.mapFrom}}
                                    <!-- <ng-container *ngIf="farmtypeid===DataFarmType.task; else activity">
                                        <ng-container *ngIf="rule.mapFrom==getFieldType(rule.mapFrom); else defaultCase">

                                        </ng-container>
                                        <ng-template #defaultCase>
                                            {{rule.mapFrom}}
                                        </ng-template>
                                    </ng-container>
                                    <ng-template #activity>
                                        <ng-container *ngIf="rule.isSubHeader; else defaultCase">

                                        </ng-container>
                                        <ng-template #defaultCase>
                                            {{rule.mapFrom}}
                                        </ng-template>
                                    </ng-template> -->
                                </td>
                            </ng-container>
                    
                            <ng-container matColumnDef="mapType">
                                <th mat-header-cell *matHeaderCellDef style="width: 70px;text-align: center;"> Map </th>
                                <td mat-cell *matCellDef="let rule" style="width: 70px;text-align: center;">
                                    <!-- {{MapControlLegendTypeUtil.toString(rule.mapType)}} -->
                                    <img [src]="MapControlLegendTypeUtil.toString(rule.mapType)" alt="" width="50">
                                </td>
                            </ng-container>
                    
                            <ng-container matColumnDef="mapTo">
                                <th mat-header-cell *matHeaderCellDef [style.--td-color]="getstylemapTo()['--td-color']" class="td-colored"> {{maptotext}} </th>
                                <td mat-cell *matCellDef="let rule" [style.--td-color]="getstylemapTo()['--td-color']" class="td-colored">
                                    {{rule.mapTo}}
                                </td>
                            </ng-container>
                    
                            <ng-container matColumnDef="mapShow">
                                <th mat-header-cell *matHeaderCellDef style="width: 70px;text-align: center;"> Show in Result
                                </th>
                                <td mat-cell *matCellDef="let rule" style="width: 70px;text-align: center;">
                                    <ng-container *ngIf="rule.mapTo === 'row'; else disableMapShow">
                                        <mat-slide-toggle color="primary" [(ngModel)]="rule.mapShow" style="margin: 0px !important;" [disabled]="true"></mat-slide-toggle>
                                    </ng-container>
                                    <ng-template #disableMapShow>
                                        <mat-slide-toggle color="primary" [(ngModel)]="rule.mapShow" style="margin: 0px !important;"></mat-slide-toggle>
                                    </ng-template>
                                </td>
                            </ng-container>
                        
                            <!-- Header row first group -->
                            <ng-container matColumnDef="required">
                            <th [attr.colspan]="4" mat-header-cell *matHeaderCellDef style="text-align: left;border-bottom:0px;"> Required Conversions </th>
                            </ng-container>
                            
                            <tr mat-header-row *matHeaderRowDef="['required']">
                            </tr>
                            <tr mat-header-row *matHeaderRowDef="displayedColumnsdef; sticky:true"></tr>
                            <tr class="drag-component" mat-row *matRowDef="let row; columns: displayedColumnsdef;" [hidden]="row.isDefault == false"></tr>
                    
                            <div *cdkDragPlaceholder></div>
                    
                            </table>
                        </td>
                        <!-- <td style="width: 1px; border-right: 1px solid #ffa600;"></td> -->
                        <td style="vertical-align: top;padding-right: 10px;padding-left: 10px;">
                            <div style="height: 349px;overflow-y: auto;">
                                <table *ngIf="!isRuleSetEmpty" mat-table
                                [dataSource]="dataSource" #table class="drag-list mat-elevation-z8" cdkDropList
                                [cdkDropListData]="dataSource">
    
                                <ng-container matColumnDef="mapInclude">
                                    <th mat-header-cell *matHeaderCellDef style="width: 70px;text-align: center;"> Include 
                                    </th>
                                    <td mat-cell *matCellDef="let rule" style="width: 70px;text-align: center;">
                                        <ng-container *ngIf="isShowDropdownMapType(rule); else showDropdownMapInclude">
                                            <mat-slide-toggle color="primary" [(ngModel)]="rule.mapInclude" disabled style="margin: 0px !important;"></mat-slide-toggle>
                                        </ng-container>
                                        <ng-template #showDropdownMapInclude>
                                            <mat-slide-toggle color="primary" [(ngModel)]="rule.mapInclude" (change)="onToggleInclude(rule)" [disabled]="rule.mapTo==undefined" style="margin: 0px !important;"></mat-slide-toggle>
                                        </ng-template>
                                    </td>
                                </ng-container>
    
                                <ng-container matColumnDef="mapFrom">
                                    <th mat-header-cell *matHeaderCellDef [style.--td-color]="getstylemapFrom()['--td-color']" class="td-colored">{{mapfromtext}} </th>
                                    <td mat-cell *matCellDef="let rule" [style.--td-color]="getstylemapFrom()['--td-color']" class="td-colored">
                                        {{rule.mapFrom}}
                                    </td>
                                </ng-container>
    
                                <ng-container matColumnDef="mapType">
                                    <th mat-header-cell *matHeaderCellDef style="width: 70px;text-align: center;"> Map </th>
                                    <td mat-cell *matCellDef="let rule" style="width: 70px;text-align: center;" >
                                        <ng-container *ngIf="isShowDropdownMapType(rule); else showDropdownMapType">
                                            <img [src]="MapControlLegendTypeUtil.toString(rule.mapType)" alt="" width="50" style="margin-right: 20px;">
                                        </ng-container>
                                        <ng-template #showDropdownMapType>
                                        <mat-select [(ngModel)]="rule.mapType" style="width: 70px;">
                                            <mat-select-trigger>
                                                <img [src]="MapControlLegendTypeUtil.toString(rule.mapType)" alt="" width="50">
                                            </mat-select-trigger>
                                            <!-- <mat-option></mat-option> -->
                                            <mat-option *ngFor="let condType of MapControlLegendTypesOptional" [value]="condType">
                                                <img [src]="MapControlLegendTypeUtil.toString(condType)" alt="" width="50">
                                            </mat-option>
                                        </mat-select>
                                        </ng-template>
                                    </td>
                                </ng-container>
    
                                <ng-container matColumnDef="mapTo">
                                    <th mat-header-cell *matHeaderCellDef [style.--td-color]="getstylemapTo()['--td-color']" class="td-colored"> {{maptotext}} </th>
                                    <td mat-cell *matCellDef="let rule; let i = index" [style.--td-color]="getstylemapTo()['--td-color']" class="td-colored" style="width: 120px;">
                                        <ng-container *ngIf="isShowDropdownMapType(rule); else showDropdownMapTo">
                                            {{rule.mapTo}}
                                        </ng-container>
                                        <ng-template #showDropdownMapTo>
                                            <app-autocomplete-field 
                                                [options]="options" 
                                                [disabledColumns]="disabledColumns"
                                                [placeholder]="defaultTargetColumn" 
                                                [(ngModel)]="rule.mapTo"
                                                (selectionChange)="onTargetColumnChanged(rule, $event)"
                                                (moveToNextField)="handleMoveToField($event, i)" (ngModelChange)="onMapToChange(rule)" [tabIndex]="i"
                                                ></app-autocomplete-field>
                                            <!-- <mat-select [(ngModel)]="rule.mapTo" (ngModelChange)="onMapToChange(rule)" placeholder="None">
                                                <mat-select-trigger>
                                                    <span [style.--td-color]="getstylemapTo()['--td-color']" class="td-colored">{{rule.mapTo}}</span>
                                                </mat-select-trigger>
                                                <mat-option>None</mat-option>
                                                <mat-option *ngFor="let col of viewModel.targetColumns" [value]="col"><span [style.--td-color]="getstylemapTo()['--td-color']" class="td-colored">{{col}}</span>
                                                </mat-option>
                                            </mat-select> -->
                                        </ng-template>
                                        
                                    </td>
                                </ng-container>
    
                                <ng-container matColumnDef="mapShow">
                                    <th mat-header-cell *matHeaderCellDef style="width: 70px;text-align: center;"> Show in Result
                                    </th>
                                    <td mat-cell *matCellDef="let rule" style="width: 70px;text-align: center;">
                                        <mat-slide-toggle color="primary" [(ngModel)]="rule.mapShow" *ngIf="rule.mapInclude" style="margin: 0px !important;"></mat-slide-toggle>
                                    </td>
                                </ng-container>
                            
                                <!-- Header row first group -->
                                <ng-container matColumnDef="optional">
                                <th [attr.colspan]="5" mat-header-cell *matHeaderCellDef style="text-align: left;border-bottom:0px;"> Optional Conversions</th>
                                </ng-container>
    
                                <tr mat-header-row *matHeaderRowDef="['optional']">
                                </tr>
                                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
                                <tr class="drag-component" mat-row *matRowDef="let row; columns: displayedColumns;" [hidden]="row.isDefault == true"></tr>
    
                                <div *cdkDragPlaceholder></div>
    
                                </table>
                            </div>
                        </td>
                        <td style="vertical-align: top;margin-right: 10px;">
                            <table style="color: lightgray;margin-left: 30px;padding: 10px;">
                                <tr>
                                    <td colspan="2" style="font-style: italic;font-weight: 500;color: #536c7e;">Map Controls Legend </td>
                                </tr>
                                <tr>
                                    <td>Control</td>
                                    <td>Action</td>
                                </tr>
                                <tr>
                                    <td><img src="../assets/images/fcoptionone.png" alt="" width="50"></td>
                                    <td>Mapped from first Row</td>
                                </tr>
                                <tr>
                                    <td><img src="../assets/images/fcoptiontwo.png" alt="" width="50"></td>
                                    <td>Create list from grouped rows</td>
                                </tr>
                                <tr>
                                    <td><img src="../assets/images/fcoptionthree.png" alt="" width="50"></td>
                                    <td>Use first and last rows </td>
                                </tr>  
                                <tr>
                                    <td><img src="../assets/images/fcoptionfour.png" alt="" width="50"></td>
                                    <td>Built-in aggregation logic</td>
                                </tr>
                                <tr>
                                    <td><img src="../assets/images/fcoptionfive.png" alt="" width="50"></td>
                                    <td>Sum values (numeric fields) </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </div>
        </mat-expansion-panel>
        <!-- Results Dashboard -->
        <mat-expansion-panel class="mat-elevation-z0">
            <mat-expansion-panel-header>Results Dashboard</mat-expansion-panel-header>
            <mat-tab-group animationDuration="300ms">
                <mat-tab label="Results">
                    <div style="position: relative">
                        <div style="position: absolute;left:200px;top:4px">
                            <mat-form-field style="width: 120px;" appearance="outline">
                                <mat-label>Input Rows</mat-label>
                                <input readonly matInput placeholder="Input Rows" type="text" [value]="viewModel.inputRows | number">
                            </mat-form-field>
                            <mat-form-field style="width: 120px;margin-left: 3px;" appearance="outline">
                                <mat-label>Output Rows</mat-label>
                                <input readonly matInput placeholder="Output Rows" type="text" [value]="viewModel.outputRows | number">
                            </mat-form-field>
                            <mat-form-field style="width: 140px;margin-left: 3px;" appearance="outline">
                                <mat-label>Aggregation Ratio</mat-label>
                                <input readonly matInput placeholder="Aggregation Ratio" type="text" [(ngModel)]="viewModel.aggRatioDisplay">
                            </mat-form-field>
                            <mat-form-field *ngIf="lastDtrRunTime" style="width: 120px; margin-left: 3px;" appearance="outline">
                                <mat-label>Uncompiled</mat-label>
                                <input type="text" readonly matInput [value]="lastDtrRunTime"
                                    matTooltip="Run Time (uncompiled) — time taken by the generic engine to execute this transform" matTooltipPosition="above">
                            </mat-form-field>
                            <mat-form-field *ngIf="lastDtrRunTime && isCompilable" style="width: 120px; margin-left: 3px;" appearance="outline">
                                <mat-label>When compiled</mat-label>
                                <input type="text" readonly matInput [value]="lastCompiledRunTime"
                                    matTooltip="Preview only — how fast the compiled fast-path engine would run this transform's CURRENT config (saved or not), not necessarily what production is using right now. Save to make this the actual compiled plan production runs. NA when the config isn't fully compilable or its own Run All Rows setting is off." matTooltipPosition="above">
                            </mat-form-field>
                        </div>
                        <app-preview-table [delegate]="this" #previewTable [hideRefresh]="true" [hideOptions]="true" previewType="converterResult" previewTypeName="Result"
                            [viewModel]="previewDataViewModel"  ></app-preview-table>
                    </div>
                </mat-tab>
                <mat-tab label="Summary">
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryResult" #menuTriggerResult="matMenuTrigger"  style="margin-top: 3px;margin-left: 20px;margin-right: 50px;" (click)="showSelectFilterResult(menuTriggerResult)">Summary Fields</button>
                    <span>{{ totalSummaryRowsResult }}</span>
                    <mat-menu #menusummaryResult="matMenu" yPosition="below" style="margin-top: 2% !important;">
                        <app-select-filter-option [values]="selectValuesResult" [valuesColor]="selectValuesColorResult" [sources]="datafarmSourcesResult" [source]="sourceResult" [emptyColumns]="selectEmptyColumnsResult" [selectedColumns]="selectFilterValuesResult" columnName="Summary" (clearFilter)="onClearSelectResult($event)" (applyFilter)="onApplySelectResult($event)" (closeFilter)="onCloseSelectResult()"></app-select-filter-option>
                    </mat-menu>
                    <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableResult [hideRefresh]="true" previewType="Summary" 
                        [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
                </mat-tab>
            </mat-tab-group>
        </mat-expansion-panel>
        <!-- Data Farm Preview -->
        <mat-expansion-panel class="mat-elevation-z0">
            <mat-expansion-panel-header (click)="setFarmConverterPreviewTabClicked()">Data Farm Preview</mat-expansion-panel-header>
            <mat-tab-group animationDuration="300ms" (selectedTabChange)="onTabClick($event)">
                <mat-tab label="Input ({{inputcolumncount}})">
                    <div style="position: relative;">
                        <app-preview-table [delegate]="this" #inputDataFarmPreviewTable [hideRefresh]="true"
                            [hideOptions]="true" [viewModel]="previewDataViewModel" previewType="converterInput" previewTypeName="Input"  ></app-preview-table>
                    </div>
                </mat-tab>
                <mat-tab label="Output ({{outputcolumncount}})">
                    <app-preview-table [delegate]="this" #outputDataFarmPreviewTable [hideRefresh]="true"
                        [hideOptions]="true" [viewModel]="previewDataViewModel" previewType="converterOutput" previewTypeName="Output"  ></app-preview-table>
                </mat-tab>
                <mat-tab label="Summary (Input)">
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryinput" #menuTriggerInput="matMenuTrigger"  style="margin-top: 3px;margin-left: 20px;margin-right: 50px;" (click)="showSelectFilter(menuTriggerInput,'Input')">Summary Fields</button>
                    <span>{{ totalSummaryRowsInput }}</span>
                    <mat-menu #menusummaryinput="matMenu" yPosition="below" style="margin-top: 2% !important;">
                        <app-select-filter-option [values]="selectValuesInput" source="Input" [emptyColumns]="selectEmptyColumnsInput" [selectedColumns]="selectFilterValuesInput" columnName="Summary" (clearFilter)="onClearSelect($event)" (applyFilter)="onApplySelect($event)" (closeFilter)="onCloseSelect()" (changeSource)="onChangeSource($event)"></app-select-filter-option>
                    </mat-menu>
                    <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableInput [hideRefresh]="true" previewType="Summary" 
                        [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
                </mat-tab>
                <mat-tab label="Summary (Output)">
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryoutput" #menuTriggerOutput="matMenuTrigger"  style="margin-top: 3px;margin-left: 20px;margin-right: 50px;" (click)="showSelectFilter(menuTriggerOutput,'Output')">Summary Fields</button>
                    <span>{{ totalSummaryRowsOutput }}</span>
                    <mat-menu #menusummaryoutput="matMenu" yPosition="below" style="margin-top: 2% !important;">
                        <app-select-filter-option [values]="selectValuesOutput" source="Output" [emptyColumns]="selectEmptyColumnsOutput" [selectedColumns]="selectFilterValuesOutput" columnName="Summary" (clearFilter)="onClearSelect($event)" (applyFilter)="onApplySelect($event)" (closeFilter)="onCloseSelect()" (changeSource)="onChangeSource($event)"></app-select-filter-option>
                    </mat-menu>
                    <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableOutput [hideRefresh]="true" previewType="Summary" 
                        [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
                </mat-tab>
            </mat-tab-group>
        </mat-expansion-panel>
        <!-- Data Farm Export -->
        <mat-expansion-panel [disabled]="isDisabled" [expanded]="!isDisabled" class="mat-elevation-z0">
            <mat-expansion-panel-header (click)="DataFarmExport()">Data Farm Export</mat-expansion-panel-header>
            <app-export-output-data #exportOutputData [hideOptions]="true" 
            [viewModelExport]="viewModelExport"></app-export-output-data>
        </mat-expansion-panel>
        <!-- Data Writer -->
        <mat-expansion-panel [disabled]="isDisabledDW" [expanded]="!isDisabledDW" class="mat-elevation-z0">
            <mat-expansion-panel-header (click)="DataWriter()">Data Writer</mat-expansion-panel-header>
            <app-export-output-data-dynamic></app-export-output-data-dynamic>
        </mat-expansion-panel>
    </mat-card-content>
</mat-card>